module.exports = __webpack_public_path__ + "assets/img/nav-item-5-active-b010de94.png";